import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { ComposedActions } from '../../helpers/actions';

enum DeviceStatus {
  Online = 'online',
  StandBy = 'standby',
  Offline = 'offline',
}

export const tabs = [
  {
    label: 'CMS',
    id: 'cms',
    status: DeviceStatus.Online,
    enabled: true,
    available: true,
  },
  {
    label: 'AIS',
    id: 'ais',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: '3D RADAR',
    id: 'radar_3d',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'EOSS',
    id: 'eoss',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'R-E0 76 mm',
    id: 'r_e0_76mm',
    status: DeviceStatus.StandBy,
    enabled: true,
    available: true,
  },
  {
    label: 'EW/R',
    id: 'ew_r',
    status: DeviceStatus.Online,
    enabled: true,
    available: true,
  },
  {
    label: 'TAS',
    id: 'tas',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'SAM',
    id: 'sam',
    status: DeviceStatus.Online,
    enabled: true,
    available: true,
  },
  {
    label: 'RWS PORT',
    id: 'rws_port',
    status: DeviceStatus.Online,
    enabled: true,
    available: true,
  },
  {
    label: 'CDL',
    id: 'cdl',
    status: DeviceStatus.Offline,
    enabled: true,
    available: true,
  },
  {
    label: 'A/C',
    id: 'a_c',
    status: DeviceStatus.StandBy,
    enabled: true,
    available: true,
  },
  {
    label: 'NDN',
    id: 'ndn',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'NAVR SYS',
    id: 'navr_sys',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'IFF',
    id: 'iff',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'DLS',
    id: 'dls',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'E0 35 mm',
    id: 'e0_35_mm',
    status: DeviceStatus.StandBy,
    enabled: true,
    available: true,
  },
  {
    label: 'EW/C',
    id: 'ew_c',
    status: DeviceStatus.Online,
    enabled: true,
    available: true,
  },
  {
    label: 'TLS',
    id: 'tls',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'SSM',
    id: 'ssm',
    status: DeviceStatus.Online,
    enabled: true,
    available: false,
  },
  {
    label: 'RWS STBD',
    id: 'rws_stbd',
    status: DeviceStatus.Online,
    enabled: true,
    available: true,
  },
  {
    label: 'TDL',
    id: 'tdl',
    status: DeviceStatus.StandBy,
    enabled: true,
    available: true,
  },
  {
    label: 'UAS',
    id: 'uas',
    status: DeviceStatus.Online,
    enabled: false,
    available: true,
  },
];

const TabContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 5px;
`;

const TabItem = styled.div<any>`
  width: 120px;
  height: 35px;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  margin: 4px;
  color: white;
  border: outset 1px black;
  cursor: pointer;
  user-select: none;
  box-sizing: content-box;

  ${({ available }) => {
    if (available) {
      return `
          background: #1f2848;
          background-image: -webkit-linear-gradient(top, #1f2848, #101731);
          background-image: -moz-linear-gradient(top, #1f2848, #101731);
          background-image: -ms-linear-gradient(top, #1f2848, #101731);
          background-image: -o-linear-gradient(top, #1f2848, #101731);
          background-image: linear-gradient(to bottom, #1f2848, #101731);
          -webkit-border-radius: 8;
          -moz-border-radius: 8;
          border-radius: 8px;
          -webkit-box-shadow: 3px 4px 3px #666666;
          -moz-box-shadow: 3px 4px 3px #666666;
          box-shadow: 3px 4px 3px #666666;
          color: #ffffff;
          padding: 10px 20px 10px 20px;
          text-decoration: none;
          :hover {
            background-image: -webkit-linear-gradient(top,#101731, #1f2848);
          }
      `;
    } else {
      return `
            background: #2d3c64;
            background-image: -webkit-linear-gradient(top, #2d3c64, #1f2b4c);
            background-image: -moz-linear-gradient(top, #2d3c64, #1f2b4c);
            background-image: -ms-linear-gradient(top, #2d3c64, #1f2b4c);
            background-image: -o-linear-gradient(top, #2d3c64, #1f2b4c);
            background-image: linear-gradient(to bottom, #2d3c64, #1f2b4c);
            -webkit-border-radius: 8;
            -moz-border-radius: 8;
            border-radius: 8px;
            -webkit-box-shadow: 3px 4px 3px #666666;
            -moz-box-shadow: 3px 4px 3px #666666;
            box-shadow: 3px 4px 3px #666666;
            color: #ffffff;
            padding: 10px 20px 10px 20px;
            text-decoration: none;
            :hover {
              background-image: -webkit-linear-gradient(top,#1f2b4c, #2d3c64);
            }
      `;
    }
  }}

  > span {
    ${({ enabled }) => {
      if (!enabled) {
        return `color: gray;`;
      }
    }}
    text-align: center;
    margin-top: 8px;
  }
`;
const StatusLine = styled.div<any>`
  width: 100px;
  height: 5px;
  background: white;
  ${({ status, enabled, color }) => {
    if (color) {
      return `background: ${color}`;
    } else {
      return `background: rgba(71,158,3,1)`;
    }
    // if (!enabled) {
    //   return `background: gray`;
    // }
    // if (status === DeviceStatus.StandBy) {
    //   return `background: white`;
    // }
    // if (status === DeviceStatus.Online) {
    //   return `background: rgba(71,158,3,1)`;
    // }
    // if (status === DeviceStatus.Offline) {
    //   return `background: rgba(251,0,7,1)`;
    // }
    // return ``;
  }}
`;
export default function GlobalTab() {
  const dispatch = useDispatch();
  const tabStatusLineColor = useSelector(
    (state: any) => state.executor.catiz.tabStatusLineColor
  );
  const handleClick = (item) => {
    dispatch(
      ComposedActions.PressGeneralButtonSwitch.aCreator({
        id: item,
        isActive: true,
      })
    );
  };
  return (
    <TabContainer>
      {tabs.map((tab) => {
        return (
          <TabItem
            available={tab.available}
            id={tab.id}
            enabled={tab.enabled}
            onClick={() => handleClick(tab.id)}
          >
            <span>{tab.label}</span>
            <StatusLine
              status={tab.status}
              enabled={tab.enabled}
              color={tabStatusLineColor[tab.id]}
            />
          </TabItem>
        );
      })}
    </TabContainer>
  );
}
